// Module
var code = `<div class="profile-body">
  <div class="tab-menu">
    <ul class="nav-tabs">
      <li class="active">
        <a data-target="#cpr_tab_base_data"
           data-toggle="tab">
          <span>
            <i ng-if="\$ctrl.individualDataForm.\$invalid"
               class="icon icon-warning-sign">
          </i>
            Individual Data
          </span>
        </a>
      </li>
      <li>
        <a data-target="#cpr_tab_addresses"
           data-toggle="tab">
          <span>
            <i ng-if="\$ctrl.addressesForm.\$invalid"
               class="icon icon-warning-sign">
            </i>
            Addresses
          </span>
        </a>
      </li>
      <li>
        <a data-target="#cpr_tab_documents"
           data-toggle="tab">
          <span>
            <i ng-if="\$ctrl.documentsForm.\$invalid || \$ctrl.candidacy.customer.idDocuments.length < 1"
               class="icon icon-warning-sign">
            </i>
            Documents
          </span>
        </a>
      </li>
      <li>
        <a data-target="#cpr_tab_income"
           data-toggle="tab">
          <span>
            <i ng-if="\$ctrl.incomeForm.\$invalid || \$ctrl.candidacy.customer.incomeSources.length < 1"
               class="icon icon-warning-sign">
            </i>
            Business information
          </span>
        </a>
      </li>
    </ul>
  </div>

  <form name="\$ctrl.mainForm">
    <div class="tab-content">
      <div id="cpr_tab_base_data"
           class="tab-pane active">
        <customer-profile-individual-data
          profile="\$ctrl.candidacy.customer"
          edit-mode="\$ctrl.editMode && !\$ctrl.candidacy.customer.id"
          ng-form="\$ctrl.individualDataForm"
          module="\$ctrl.module">

        </customer-profile-individual-data>
      </div>
      <div id="cpr_tab_addresses"
           class="tab-pane">
        <customer-profile-addresses
          addresses="\$ctrl.candidacy.customer.addresses"
          edit-mode="\$ctrl.editMode && !\$ctrl.candidacy.customer.id"
          ng-form="\$ctrl.addressesForm"
          module="\$ctrl.module">
        </customer-profile-addresses>
      </div>
      <div id="cpr_tab_documents"
           class="tab-pane">
        <div class="alert" ng-if="\$ctrl.candidacy.customer.id && \$ctrl.editMode">
          It's only possible to modify or add new 'Documents' in this view.
          You can remove existing 'Documents' from Customer's profile.
          <button type="button" class="close" data-dismiss="alert">&times;</button>
        </div>
        <customer-profile-documents
          id-documents="\$ctrl.candidacy.customer.idDocuments"
          profile="\$ctrl.candidacy.customer"
          edit-mode="\$ctrl.editMode"
          ng-form="\$ctrl.documentsForm"
          module="\$ctrl.module">
        </customer-profile-documents>
        <validator condition="\$ctrl.candidacy.customer.idDocuments.length > 0">
        </validator>
      </div>
      <div id="cpr_tab_income"
           class="tab-pane">
        <div class="alert" ng-if="\$ctrl.candidacy.customer.id && \$ctrl.editMode">
          It's only possible to modify or add new 'Business Information' in this view.
          You can remove existing 'Business Information' from Customer's profile.
          <button type="button" class="close" data-dismiss="alert">&times;</button>
        </div>
        <customer-profile-income
          profile="\$ctrl.candidacy.customer"
          edit-mode="\$ctrl.editMode"
          ng-form="\$ctrl.incomeForm"
          module="\$ctrl.module">
        </customer-profile-income>
        <validator condition="\$ctrl.candidacy.customer.incomeSources.length > 0"></validator>
      </div>
    </div>
  </form>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/agent-banking/candidacy/agent-customer-profile-body.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;